import React, { useEffect, useState } from "react";
import Translations from "../../services/translation.service";
import StorefrontTitle from "../shared/storefront-title.component";
import ZigZag from "../../assets/img/Bottomzigzag.svg";
import SpinnerTimeLoader from "../shared/timeLoading";
import Storage from "../../services/storage.service";
import CommonPayment from "../shared/commonPayments/common-payment-index";
import moment from 'moment';
import CommonPaymentLogo from "../payment/common-payment-logo";
import Helpers from "../../helpers/shared.helper";
import SimDeactivationService from "../../services/sim-deactivation.service";
import FirebaseAnalytics from "../../services/analytics.service";
import "moment/locale/ar-sa";
import "moment/locale/en-ca";

const subscriptions = [];
const ClosingBillSummary = props => {
  const { history } = props;
  const [translationKeys, setTranslationsKeys] = useState(
    Translations.keys ? Translations.keys : {}
  );
  const [loading, setLoading] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const [closingBillDetails, setClosingBillDetails] = useState(null);
  const [formValues, setFormValues] = useState();
  // Prepare Data for TAP Payment
  const [tapPayload, setTapPayload] = useState({
    paymentData: {
      number: null,
      amount: 0,
    },
    apiEndpoint: {
      endpoint: "/postpaid_bills/pay_with_new_card_web",
      method: "post"
    },
    extraInformation: {
      totalAmount: 0,
      payingFor: "sim_deactivation",
      showAppDownloads: true,
      showPaymentLogos: true
    }
  });

  // Prepare Data for Apple Pay
  const [applePayload, setApplePayload] = useState({
    paymentData: {
      number: null,
      amount: 0
    },
    apiEndpoint: {
      endpoint: "/postpaid_bills/pay_with_apple_web",
      successURL: "/join/#/confirmation-apple-sim-deactivation",
      failureURL: "/join/#/apple-pay-sim-deactivation-failure",
      method: "post"
    },
    extraInformation: {
      totalAmount: 0,
      payingFor: "sim_deactivation",
      showAppDownloads: false,
      showPaymentLogos: false,
    }
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    FirebaseAnalytics.generic_event(2);
    subscriptions.push(
    Translations.getKeysObsrv().subscribe((data) => {
        setTranslationsKeys(data);
    })
    );

    return () => {
    if (subscriptions && subscriptions?.length) {
        for (let subscription of subscriptions) {
        subscription.unsubscribe();
        }
    }
    };
  }, []);

  const getBillDetails = (phone) => {
    Storage.set("simDeactivationRoute", "closingSummary", true);
    Storage.get("genericAPIError", true, true);
    setLoading(true);
    let countryCode = Helpers.getCountryCodePO() || "";
    let number = `${countryCode}${phone?.replace(/^0+/, '')}`;
    SimDeactivationService.getClosingBills(number)
    .then((response) => {
      if(response?.data) {
        setClosingBillDetails(response.data);
        if(response?.data?.FullOutstandingAmountVated) {
          let amount = response?.data?.FullOutstandingAmountVated;  
          setTapPayload(prevState => ({
            ...prevState,
            paymentData: {
              ...prevState.paymentData,
              number: number,
              amount: amount
            },
            extraInformation: {
              ...prevState.extraInformation,
              totalAmount: amount
            }
          }));
      
          setApplePayload(prevState => ({
            ...prevState,
            paymentData: {
              ...prevState.paymentData,
              number: number,
              amount: amount
            },
            extraInformation: {
              ...prevState.extraInformation,
              totalAmount: amount
            }
          }));
        }
        setLoading(false);
      }
    })
    .catch(() => {
      setLoading(true);
    })
  };

  useEffect(() => {
    // Check if state exists in history.location and set the data accordingly
    if (history?.location?.state && history?.location?.state?.formValues) {
      const formData = history?.location?.state?.formValues;
      setFormValues(formData);
      getBillDetails(formData?.phone);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const showPaymentOnly = (data) => {
    setShowPayment(data);
  }

  const selectedPaymentMethod = (data) => {
    Storage.set("SelectedPaymentMethodTemp", data);
    FirebaseAnalytics.generic_event(10);
  }

  const getConvertedBillDate = (dateStringStart, dateStringEnd) => {
    if (Translations.activeLang === "en") {
      moment.locale("en-ca");
    }
		if (Translations.activeLang === "ar") {
      moment.locale("ar-sa");
    }
    const start = moment(dateStringStart);
    const end = moment(dateStringEnd);
    const formattedStart = start.format('DD MMM');
    const formattedEnd = end.format('DD MMM YYYY');
    return `${formattedStart} - ${formattedEnd}`
  }

  const getVatPercentage = () => {
    let vat_percentage = JSON.parse(Storage.get("business", true))[
      "vat_percentage"
    ];
    return vat_percentage || 0
  }

  const processPayLater = () => {
    FirebaseAnalytics.generic_event(9);
    Storage.clear("genericAPIError")
    Storage.get("genericAPIError", true, true);
    setLoading(true);
    if(formValues?.idNumber) {
      let countryCode = Helpers.getCountryCodePO() || "";
      let contactNumber = formValues?.contact;
      let contact_phone = `${countryCode}${contactNumber?.replace(/^0+/, '')}`;
      const data = {
        id_number: formValues?.idNumber,
        id_type: formValues?.idType,
        contact_phone: contact_phone,
        iban: formValues?.IBAN,
        reason: formValues?.reason
      }
      SimDeactivationService.CreateTerminationTicket(data)
      .then((response) => {
        if(response.data) {
          Storage.clear("genericAPIError");
          props.history.push({
            pathname: '/sim-deactivation/suspended',
            state: { formValues: formValues }
          });
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(true);
        Storage.clear("genericAPIError");
      })
    }
  }

  let content = (
    <div className="stf-deactivation-bill-wrapper">
      <StorefrontTitle
        title={translationKeys["stm_sim_deactivation_pay_before"]}
        desc={translationKeys["stm_sim_deactivation_pay_before_desc"]}
      />
      {loading ? <SpinnerTimeLoader /> :
      <>
      {!showPayment ?
        <div className="sim-deactivation-bill-clear-container">
          <div className={`sim-deactivation-bill-clear ${Helpers.isSafari() ? "safari" : ""}`}>
            <div className="sim-deactivation-bill-clear-content">
              <div className="sim-deactivation-bill-clear-header">
                <div>
                    <div>{translationKeys["stm_sim_deactivation_bill_date"]}</div>
                    <span>
                      {closingBillDetails?.BillStartDate && closingBillDetails?.BillEndtDate ? <>{getConvertedBillDate(closingBillDetails?.BillStartDate, closingBillDetails?.BillEndtDate)}</> : ""}
                    </span>
                </div>
                <div className="bill-status-container">
                  <div className="bill-status">
                    {translationKeys["stm_sim_deactivation_bill_unpaid"]}
                  </div>
                </div>
              </div>
              <hr />
              <div className="sim-deactivation-bill-clear-sub-content">
                <div className="sim-deactivation-bill-clear-details">
                  <div>{translationKeys["stm_sim_deactivation_total_bill_amt"]}<span>{translationKeys["stm_sim_deactivation_vat_inc"]}</span></div>
                  <div>{closingBillDetails?.BilledAmount ? Helpers.formatWithPORemoveCommas(closingBillDetails?.BilledAmount) : "0"}{" "}{translationKeys["stm_general_currency"]}</div>
                </div>
                <div className="sim-deactivation-bill-clear-details">
                  <div>{translationKeys["stm_sim_deactivation_total_unbill_amt"]}<span>{translationKeys["stm_sim_deactivation_vat_exc"]}</span></div>
                  <div>{closingBillDetails?.UnbilledAmounts ? Helpers.formatWithPORemoveCommas(closingBillDetails?.UnbilledAmounts) : "0"}{" "}{translationKeys["stm_general_currency"]}</div>
                </div>
                {getVatPercentage() > 0 ?
                <div className="sim-deactivation-bill-clear-details">
                  <div>{translationKeys["stm_sim_deactivation_vat"]}{" "}({getVatPercentage()}%)</div>
                  <div>{closingBillDetails?.VatAmount ? Helpers.formatWithPORemoveCommas(closingBillDetails?.VatAmount) : "0"}{" "}{translationKeys["stm_general_currency"]}</div>
                </div> : ""}
                <div className="sim-deactivation-bill-clear-details-header">
                  <div>{translationKeys["stm_sim_deactivation_total_amt"]}<span>{translationKeys["stm_sim_deactivation_vat_inc"]}</span></div>
                  <div>{closingBillDetails?.FullOutstandingAmountVated ? Helpers.formatWithPORemoveCommas(closingBillDetails?.FullOutstandingAmountVated) : "0"}{" "}{translationKeys["stm_general_currency"]}</div>
                </div>
              </div>
            </div>
            <img src={ZigZag} alt=""/>
          </div>
        </div> : ""}

        <CommonPayment
          selectedPaymentMethod={(data) => selectedPaymentMethod(data)} 
          showPaymentOnly={(data) => showPaymentOnly(data)} 
          tapPayload={tapPayload}
          applePayload={applePayload}
          paymentDisabled={false}
          hidePaymentLogo={true}
          hideForZeroPayment={true}
        />
        {!showPayment ? <div className="sim-deactivation-pay-later" onClick={processPayLater}>{translationKeys["stm_sim_deactivation_pay_later"]}</div> : ""}
        <CommonPaymentLogo />
      </>}
    </div>

  );
  return <>
    {content}
  </>;
};
export default ClosingBillSummary;
